/* omg orea: stanje (prije / na-dan / poslije) po vremenu u Europe/Sarajevo + odbrojavanje.
   koristi ga sections/omg-orea.liquid i sections/omg-orea-banner.liquid preko data atributa:
   [data-orea] root: data-start, data-end, data-tz, data-override (auto|prije|na-dan|poslije), data-hide-after (opcionalno)
   [data-orea-show="prije na-dan"] elementi se prikazuju samo u navedenim stanjima
   [data-orea-unit="d|h|m|s"] brojevi odbrojavanja */
(function () {
  function partsIn(tz, ms) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var o = {};
    f.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
    return Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour, +o.minute, +o.second);
  }
  /* "2026-11-08T11:00" kao lokalno vrijeme u tz -> ms (UTC), pravi offset iz IANA zone (i ljetno/zimsko) */
  function zoned(str, tz) {
    var m = String(str || '').match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var off = partsIn(tz, guess) - guess;
    var utc = guess - off;
    var off2 = partsIn(tz, utc) - utc;
    return off2 === off ? utc : guess - off2;
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function init(root) {
    var tz = root.getAttribute('data-tz') || 'Europe/Sarajevo';
    var start = zoned(root.getAttribute('data-start'), tz);
    var end = zoned(root.getAttribute('data-end'), tz);
    var hideAfter = zoned(root.getAttribute('data-hide-after'), tz);
    var ov = root.getAttribute('data-override') || 'auto';
    /* samo za pregled: ?orea=prije|na-dan|poslije (ili teaser = prije, reveal = poslije) */
    var q = (location.search.match(/[?&]orea=(prije|na-dan|poslije|teaser|reveal)/) || [])[1];
    if (q === 'teaser') q = 'prije';
    if (q === 'reveal') q = 'poslije';
    if (q) ov = q;
    /* proizvodi online od (data-online): do tada linkovi kartica [data-or-link] nisu klikabilni. pregled: ?orea_online=1|0 */
    var online = zoned(root.getAttribute('data-online'), tz);
    var qo = (location.search.match(/[?&]orea_online=(0|1)/) || [])[1];
    var curOn = null;
    function gate(now) {
      var on = qo ? qo === '1' : (isNaN(online) || now >= online);
      if (on === curOn) return;
      curOn = on;
      root.setAttribute('data-orea-online', on ? '1' : '0');
      root.querySelectorAll('[data-or-link]').forEach(function (a) {
        if (!a.hasAttribute('data-href')) a.setAttribute('data-href', a.getAttribute('href') || '');
        if (on) { a.setAttribute('href', a.getAttribute('data-href')); a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
        else { a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); a.setAttribute('tabindex', '-1'); }
      });
    }
    /* 2026-10-23: tajmeri po cilju - [data-orea-cd="end"] broji do kraja (na dan), ostali do početka */
    var units = {}, unitsEnd = {};
    root.querySelectorAll('[data-orea-unit]').forEach(function (e) { var m = e.closest('[data-orea-cd="end"]') ? unitsEnd : units, k = e.getAttribute('data-orea-unit'); (m[k] = m[k] || []).push(e); });
    function put(map, left) {
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
      if (!map.d) h += d * 24;
      [['d', d], ['h', h], ['m', m], ['s', sec]].forEach(function (x) { (map[x[0]] || []).forEach(function (el) { el.textContent = pad(x[1]); }); });
    }
    var cur = null, t;

    function state(now) {
      if (ov !== 'auto') return ov;
      if (now < start) return 'prije';
      if (now < end) return 'na-dan';
      return 'poslije';
    }
    function tick() {
      var now = Date.now();
      if (!isNaN(hideAfter) && !q && root.getAttribute('data-override') === 'auto' && now >= hideAfter) {
        root.hidden = true; clearInterval(t); return;
      }
      var s = state(now);
      gate(now);
      if (s !== cur) {
        cur = s;
        root.setAttribute('data-orea-state', s);
        root.querySelectorAll('[data-orea-show]').forEach(function (e) {
          e.hidden = (' ' + e.getAttribute('data-orea-show') + ' ').indexOf(' ' + s + ' ') < 0;
        });
      }
      if (s === 'prije' && units.s) put(units, Math.max(0, Math.floor((start - now) / 1000)));
      if (s === 'na-dan' && unitsEnd.s) {
        /* pregled (?orea=na-dan) prije oree: broji kao da je 11:00 */
        var ref = now < start ? start : now;
        put(unitsEnd, Math.max(0, Math.floor((end - ref) / 1000)));
      }
    }
    tick();
    t = setInterval(tick, 1000);
  }

  function boot() { document.querySelectorAll('[data-orea]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* stranica: ulazak elemenata + tačkice za swipe kartice (mobitel) */
(function () {
  function rv() {
    var els = document.querySelectorAll('[data-or-rv]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function dots() {
    document.querySelectorAll('[data-or-swipe]').forEach(function (row) {
      var d = row.parentNode.querySelector('[data-or-dots]');
      if (!d || d.childElementCount) return;
      var cards = row.children;
      for (var i = 0; i < cards.length; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('aria-label', String(i + 1));
          b.addEventListener('click', function () { row.scrollTo({ left: cards[i].offsetLeft - row.offsetLeft, behavior: 'smooth' }); });
          d.appendChild(b);
        })(i);
      }
      function upd() {
        var i = Math.round(row.scrollLeft / Math.max(1, row.clientWidth));
        for (var k = 0; k < d.children.length; k++) d.children[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
      row.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }
  /* traka fotki: brzina po širini; prst stoji, pustiš = odmah dalje (bez 'zaglavljenog' stanja) */
  function strip() {
    document.querySelectorAll('[data-or-marquee]').forEach(function (t) {
      var sec = t.parentNode;
      function dur() { var w = t.scrollWidth / 2; var px = window.innerWidth < 750 ? 50 : 72; t.style.setProperty('--or-dur', Math.max(30, w / px) + 's'); }
      dur(); window.addEventListener('load', dur); window.addEventListener('resize', dur);
      if (sec.__orStrip) return; sec.__orStrip = 1;
      function hold() { sec.classList.add('is-held'); }
      function go() { sec.classList.remove('is-held'); }
      sec.addEventListener('touchstart', hold, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (e) { sec.addEventListener(e, go, { passive: true }); window.addEventListener(e, go, { passive: true }); });
      sec.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      document.addEventListener('visibilitychange', go);
    });
  }
  /* "ne stižeš": naše polje -> skrivena omnisend forma (isto kao kviz), poslije uspjeha event "orea prijava".
     debug: window.omgOreaDebug = true */
  function form() {
    document.querySelectorAll('[data-or-form]').forEach(function (f) {
      if (f.__or) return; f.__or = 1;
      var fid = f.getAttribute('data-omn-id'), cid = 'omnisend-embedded-v2-' + fid, pending = false, tracked = false;
      function log() { if (window.omgOreaDebug) console.log.apply(console, ['[omg-orea]'].concat([].slice.call(arguments))); }
      function toOmnisend(mail) {
        var c = document.getElementById(cid); if (!c) return false;
        var of = c.querySelector('form'); if (!of) return false;
        var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        var inp = of.querySelector('input[type="email"], input[name="email"], input[name*="mail" i]'); if (!inp) return false;
        setter.call(inp, mail); ['input', 'change', 'blur'].forEach(function (ev) { inp.dispatchEvent(new Event(ev, { bubbles: true })); });
        var consent = of.querySelector('input[type="checkbox"]'); if (consent && !consent.checked) consent.click();
        var sb = of.querySelector('button[type="submit"], input[type="submit"]');
        if (sb) sb.click(); else if (typeof of.requestSubmit === 'function') of.requestSubmit(); else of.submit();
        return true;
      }
      window.addEventListener('omnisendForms', function (e) {
        var d = e.detail || {};
        log('omnisendForms', JSON.stringify(d));
        var typ = d.type || d.eventType || d.event, id = d.formID || d.formId || (d.form && (d.form.id || d.form.formID));
        if (typ !== 'submit' || String(id) !== String(fid) || !pending || tracked) return;
        tracked = true;
        setTimeout(function () {
          window.omnisend = window.omnisend || [];
          window.omnisend.push(['track', 'orea prijava', { origin: 'api' }]);
          log('track orea prijava');
        }, 1500);
      });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var inp = f.querySelector('[data-or-mail]'), msg = f.querySelector('[data-or-msg]'), mail = inp.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { msg.textContent = f.getAttribute('data-err') || ''; inp.focus(); return; }
        msg.textContent = ''; pending = true;
        /* omnisend forma se nekad učita kasnije: pokušavaj do ~8s */
        (function tryIt(k) { var ok = false; try { ok = toOmnisend(mail); } catch (x) {} log('submit try', k, ok); if (!ok && k < 16) setTimeout(function () { tryIt(k + 1); }, 500); })(0);
        f.classList.add('is-done'); var okEl = f.querySelector('[data-or-ok]'); if (okEl) okEl.hidden = false;
      });
    });
  }
  function boot() { rv(); dots(); strip(); form(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
